import { ComponentMap } from '@cinch-nx/data-storyblok'
import { FaqAccordion } from '@cinch-nx/landing-ui-shared'
import { RichTextSection } from '@cinch-nx/landing-ui-shared'

import {
  ClauseSection,
  CookiePolicySection,
  DeleteCookiesSection,
  TableSection,
} from '../components'

export const storyblokComponents: ComponentMap = {
  ClauseSection: ClauseSection,
  CookiePolicySection: CookiePolicySection,
  TableSection: TableSection,
  DeleteCookiesSection: DeleteCookiesSection,
  RichTextSection,
  FaqSection: FaqAccordion,
}
